<template>
  <footer class="shell-footer">
    <v-sheet class="position-relative" color="secondary" width="100%">
      <v-container class="py-6">
        <div class="grid-list">
          <div class="d-flex flex-column align-start grid-list-item">
            <v-sheet
              width="100%"
              color="transparent"
              class="white--text text-body-2 text-md-h6 font-weight-bold"
            >
              <span class="font-secondary"> Contato </span>
            </v-sheet>

            <div
              v-for="(item, keyContact) in contacts"
              :key="keyContact"
              class="mx-n3"
            >
              <v-btn
                v-if="!Array.isArray(item)"
                class="white--text text-body-2 text-none btn-contact"
                :target="item.target"
                color="transparent"
                :title="item.name"
                :href="item.link"
                min-height="36px"
                height="auto"
                depressed
              >
                <v-icon
                  v-if="item.icon"
                  class="mr-2"
                  :size="item.size"
                  color="primary lighten-3"
                >
                  {{ item.icon }}
                </v-icon>

                <span class="font-secondary">
                  {{ item.text }}
                </span>
              </v-btn>

              <div v-else class="d-flex flex-column align-start">
                <v-btn
                  v-for="(
                    { name, text, link, target, icon, size }, keyContactItem
                  ) in item"
                  :key="keyContactItem"
                  class="white--text text-body-2 text-none btn-contact"
                  height="auto"
                  max-width="100%"
                  min-height="36px"
                  :href="link"
                  :target="target"
                  :title="name"
                  depressed
                  color="transparent"
                >
                  <v-icon
                    v-if="icon"
                    class="mr-2"
                    :size="size"
                    color="primary lighten-3"
                  >
                    {{ icon }}
                  </v-icon>

                  <span class="font-secondary">
                    {{ text }}
                  </span>
                </v-btn>
              </div>
            </div>

            <div class="d-flex flex-column align-start mx-n3">
              <v-btn
                class="white--text text-body-2 text-none btn-contact"
                to="/politica-de-privacidade"
                color="transparent"
                min-height="36px"
                height="auto"
                depressed
              >
                <v-icon class="mr-2" :size="18" color="primary lighten-3">
                  fa-shield
                </v-icon>

                <span class="font-secondary"> Política de Privacidade </span>
              </v-btn>
            </div>

            <div
              v-if="informations.cnpj"
              class="d-flex flex-column align-start"
            >
              <v-sheet
                class="d-flex align-center white--text text-body-2"
                color="transparent"
                min-height="36px"
              >
                <span class="font-secondary">
                  CNPJ: {{ informations.cnpj }}
                </span>
              </v-sheet>
            </div>
          </div>

          <div class="d-flex flex-column align-start grid-list-item">
            <v-sheet
              width="100%"
              color="transparent"
              class="text-body-1 text-md-h6 font-weight-bold white--text"
            >
              <span class="font-secondary">Tipos de Cestas</span>
            </v-sheet>

            <div class="d-flex mx-n3">
              <div
                v-for="basketsLength in Math.ceil(baskets.length / 6)"
                :key="basketsLength"
              >
                <div
                  v-for="({ text, to }, keyBaskets) in baskets.slice(
                    (basketsLength - 1) * 6,
                    basketsLength * 6
                  )"
                  :key="keyBaskets"
                >
                  <v-sheet min-width="200px" color="transparent">
                    <v-btn
                      class="white--text text-body-2 text-none btn-contact"
                      color="transparent"
                      min-height="36px"
                      height="auto"
                      depressed
                      :to="to"
                      exact
                    >
                      <v-icon class="mr-2" size="16"> fa-caret-right </v-icon>

                      <span class="font-secondary">
                        {{ text }}
                      </span>
                    </v-btn>
                  </v-sheet>
                </div>
              </div>
            </div>
          </div>

          <div class="grid-item">
            <v-sheet
              width="100%"
              color="transparent"
              class="text-body-1 text-md-h6 font-weight-bold white--text"
            >
              <span class="font-secondary">Redes Sociais</span>
            </v-sheet>

            <div class="d-flex justify-start align-center mx-n1">
              <div
                v-for="({ text, link, icon, size }, keySocial) in social"
                :key="keySocial"
                class="d-inline-flex"
              >
                <v-btn
                  class="text-caption text-lg-body-1 primary--text mr-2"
                  color="transparent"
                  min-width="auto"
                  target="_blank"
                  :title="text"
                  :href="link"
                  height="30px"
                  width="30px"
                  depressed
                  small
                  fab
                >
                  <v-icon :size="size" color="primary lighten-3">
                    {{ icon }}
                  </v-icon>
                </v-btn>
              </div>
            </div>

            <div class="white--text text-body-1 font-weight-bold">
              <span class="font-secondary">/cestas.comsinop</span>
            </div>
          </div>
        </div>
      </v-container>
    </v-sheet>

    <v-sheet color="primary lighten-3">
      <v-container
        class="
          pt-0
          pb-5
          d-flex
          flex-column flex-sm-row
          justify-space-between
          align-center
          text-center
        "
      >
        <div class="secondary--text text-body-2 mt-5">
          <span class="font-secondary">
            Copyright ©
            <b class="font-weight-bold">{{ year }} {{ informations.name }}</b
            >.
            <span class="d-block d-sm-inline-block">
              Todos os direitos reservados.
            </span>
          </span>
        </div>
        <a
          class="d-flex mt-5"
          href="https://www.mrxweb.com.br/"
          target="_blank"
        >
          <img
            class="shell-footer-logo"
            src="../../assets/img/mrxweb.svg"
            alt="MRX Web Sites, Publicidade, Marketing Digital, Produção de Vídeos - Sinop/MT"
            title="MRX Web Sites, Publicidade, Marketing Digital, Produção de Vídeos - Sinop/MT"
            height="20px"
          />
        </a>
      </v-container>
    </v-sheet>
  </footer>
</template>

<script>
import { getContact } from "../../utils/getContact";
import { getSocial } from "../../utils/getSocial";
import { formatToURL } from "../../utils/formatToURL";

export default {
  data: () => ({
    year: new Date().getFullYear(),
    categories: [],
  }),
  created() {
    this.$rest("categories").get({
      save: (state, data) => (this.categories = data),
    });
  },
  computed: {
    informations() {
      return this.$rest("informations").item;
    },
    contacts() {
      return getContact(this.informations);
    },
    social() {
      return getSocial(this.informations);
    },
    baskets() {
      if (!this.categories.length) return [];

      let category = this.categories.filter(
        ({ title }) => title.toLowerCase() === "cestas"
      );

      category = category[0];

      return category.subcategories
        .filter((item, index) => index < (this.xsOnly ? 6 : 12))
        .map(({ id, title }) => ({
          text: title,
          to: `/produtos?categoria=${formatToURL(category.title)}-${
            category.id
          }&subcategoria=${formatToURL(title)}-${id}`,
        }));
    },
    xsOnly() {
      return this.$vuetify.breakpoint.xsOnly;
    },
  },
};
</script>

<style lang="scss" scoped>
.shell-footer {
  .grid-list {
    display: grid;
    gap: 24px 48px;
    grid-template-columns: auto 1fr auto;
    justify-content: space-between;

    @media screen and (min-width: 600.001px) and (max-width: 960px) {
      gap: 24px;
      grid-template-columns: auto auto;

      &-item:last-child {
        grid-column-start: 1;
        grid-column-end: 3;
      }
    }

    @media screen and (max-width: 600px) {
      grid-template-columns: 1fr;
    }

    .btn-contact::v-deep {
      .v-btn__content {
        word-break: break-word;
        max-width: 100%;
        white-space: normal;
      }
    }
  }
}
</style>
